module.exports = __webpack_public_path__ + "img/-LV10_Dpz2W4G6qtB40u.f3726425.jpg";